import { POLLSTERS } from '../../data/surveys';
import type { PollsterName } from '../../data/surveys.types';
import MethodologyCard from './MethodologyCard';
import './Surveys.css';

// Display order matches the inspection HTML's three method cards.
// The EP anchor entry in POLLSTERS is intentionally excluded — it isn't
// a survey methodology.
const ORDER: PollsterName[] = [
  'MaltaToday',
  'Sagalytics',
  'Esprimi (Times of Malta)',
];

export default function MethodologyGrid() {
  return (
    <div className="methodology-grid">
      {ORDER.map((name) => (
        <MethodologyCard key={name} pollster={POLLSTERS[name]} />
      ))}
    </div>
  );
}
